import { render, staticRenderFns } from "./searchbox.vue?vue&type=template&id=b8d40ef8&scoped=true"
import script from "./searchbox.vue?vue&type=script&lang=js"
export * from "./searchbox.vue?vue&type=script&lang=js"
import style0 from "./searchbox.vue?vue&type=style&index=0&id=b8d40ef8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d40ef8",
  null
  
)

export default component.exports